import React from "react";
import { shape, bool } from "prop-types";

import GridTable from "pages/_components/GridTable/GridTable";
import FormattedDate from "pages/_components/FormattedDate";
import FormattedAmount from "pages/_components/FormattedAmount";
import CustomData from "pages/_components/CustomData/CustomData";
import I18n from "pages/_components/I18n";

const DataScheduledDebinDetail = ({ scheduledDebin, isDesktop }) => {
    const getInstallments = () => {
        const installments = [];
        for (let index = 0; index < scheduledDebin.debin.installmentLimit; index++) {
            installments.push({ number: index + 1, amount: scheduledDebin.debin.amount.quantity });
        }
        return installments;
    };

    const renderInstallmentTable = () => (
        <GridTable>
            <GridTable.Header>
                <GridTable.Container rows={2}>
                    <>
                        <GridTable.Data columnStart={1}>
                            <I18n component="span" id="debin.scheduled.detail.installmentNumber" />
                        </GridTable.Data>
                        <GridTable.Data columnStart={2}>
                            <I18n component="span" id="payments.table.amount" />
                        </GridTable.Data>
                    </>
                </GridTable.Container>
            </GridTable.Header>
            <GridTable.Body>
                {getInstallments().map((inst) => (
                    <GridTable.Container columns={2} key={inst.number}>
                        <GridTable.Data columnStart={1} rowStart={1} rowWidth={1} alignX="center">
                            {inst.number}
                        </GridTable.Data>
                        <GridTable.Data columnStart={2} rowStart={1} rowWidth={1} alignX="center">
                            <FormattedAmount
                                className="data-label"
                                currency={scheduledDebin.debin.amount.currency}
                                quantity={inst.amount}
                            />
                        </GridTable.Data>
                    </GridTable.Container>
                ))}
            </GridTable.Body>
        </GridTable>
    );

    return (
        <>
            <GridTable className="details debin-credin-list">
                <GridTable.Container columns={3} rows={1}>
                    <GridTable.Data columnStart={1} rowStart={1} columnWidth={1}>
                        <CustomData
                            titleText="debin.scheduled.acceptReject.debitAccount"
                            titleTextType="I18N"
                            valueText={scheduledDebin.buyer.shortLabel ? `····${scheduledDebin.buyer.shortLabel}` : "-"}
                        />
                    </GridTable.Data>
                </GridTable.Container>

                <GridTable.Container>
                    <GridTable.Data className="flex" columnStart={1} rowStart={1} columnWidth={3} alignX="center">
                        <GridTable.Container className="info-seller" columnWidth={3} columns={3} rows={1}>
                            <GridTable.Data rowStart={1} columnStart={1} columnWidth={1}>
                                <CustomData
                                    titleText="debin.scheduled.detail.counterparty"
                                    titleTextType="I18N"
                                    valueText={`CUIT ${scheduledDebin.seller.documentNumber}`}
                                />
                            </GridTable.Data>

                            <GridTable.Data
                                rowStart={isDesktop ? 1 : 2}
                                columnStart={isDesktop ? 3 : 1}
                                columnWidth={2}>
                                <CustomData
                                    titleText="debin.scheduled.acceptReject.planTotal"
                                    titleTextType="I18N"
                                    valueText={
                                        <FormattedAmount
                                            className="data-label"
                                            currency={scheduledDebin.debin.amount.currency}
                                            quantity={
                                                Number(scheduledDebin.debin.amount.quantity) *
                                                Number(scheduledDebin.debin.installmentLimit)
                                            }
                                        />
                                    }
                                />
                            </GridTable.Data>
                        </GridTable.Container>
                    </GridTable.Data>

                    <GridTable.Data className="flex" columnStart={1} rowStart={2} columnWidth={3}>
                        <hr className="dotted" />
                    </GridTable.Data>

                    <GridTable.Data columnStart={1} rowStart={3} columnWidth={isDesktop ? 1 : 3}>
                        <CustomData
                            titleText="debin.solicit.date"
                            titleTextType="I18N"
                            valueText={<FormattedDate showTime={false} date={scheduledDebin.creationDate} />}
                        />
                    </GridTable.Data>

                    <GridTable.Data
                        columnStart={isDesktop ? 2 : 1}
                        rowStart={isDesktop ? 3 : 4}
                        columnWidth={isDesktop ? 1 : 3}>
                        <CustomData
                            titleText="debin.scheduled.acceptReject.amount"
                            titleTextType="I18N"
                            valueText={
                                <FormattedAmount
                                    className="data-label"
                                    currency={scheduledDebin.debin.amount.currency}
                                    quantity={scheduledDebin.debin.amount.quantity}
                                />
                            }
                        />
                    </GridTable.Data>

                    <GridTable.Data
                        columnStart={isDesktop ? 3 : 1}
                        rowStart={isDesktop ? 3 : 5}
                        columnWidth={isDesktop ? 1 : 3}>
                        <CustomData
                            titleText="debin.scheduled.detail.debinID"
                            titleTextType="I18N"
                            valueText={scheduledDebin.id}
                        />
                    </GridTable.Data>

                    <GridTable.Data className="flex" columnStart={1} rowStart={isDesktop ? 4 : 6} columnWidth={3}>
                        <hr className="dotted" />
                    </GridTable.Data>

                    <GridTable.Data columnStart={1} rowStart={isDesktop ? 5 : 7} columnWidth={isDesktop ? 1 : 3}>
                        <CustomData
                            titleText="debin.scheduled.acceptReject.concept"
                            titleTextType="I18N"
                            valueText={scheduledDebin.debin.concept ? scheduledDebin.debin.concept : "-"}
                        />
                    </GridTable.Data>

                    <GridTable.Data
                        columnStart={isDesktop ? 2 : 1}
                        rowStart={isDesktop ? 5 : 8}
                        columnWidth={isDesktop ? 1 : 3}>
                        <CustomData
                            titleText="debin.scheduled.acceptReject.reference"
                            titleTextType="I18N"
                            valueText={scheduledDebin.debin.reference ? scheduledDebin.debin.reference : "-"}
                        />
                    </GridTable.Data>

                    <GridTable.Data
                        columnStart={isDesktop ? 3 : 1}
                        rowStart={isDesktop ? 5 : 9}
                        columnWidth={isDesktop ? 1 : 3}>
                        <CustomData
                            titleText="debin.scheduled.acceptReject.benefit"
                            titleTextType="I18N"
                            valueText={scheduledDebin.debin.benefit ? scheduledDebin.debin.benefit : "-"}
                        />
                    </GridTable.Data>

                    <GridTable.Data columnStart={isDesktop ? 2 : 1} rowStart={isDesktop ? 6 : 10} columnWidth={1}>
                        {renderInstallmentTable()}
                    </GridTable.Data>
                </GridTable.Container>
            </GridTable>
        </>
    );
};

DataScheduledDebinDetail.propTypes = {
    scheduledDebin: shape().isRequired,
    isDesktop: bool.isRequired,
};

export default DataScheduledDebinDetail;
